import React, { useEffect, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import { useDispatch } from "react-redux";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../redux/loader/loaderActions";
import CloseIcon from "@mui/icons-material/Close";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const ALL_TYPE_NAME = "All";

function AddTreatmentOne({ close, type }: any) {
  const [data, setData] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [edit, setedit] = useState(false);
  const [error, seterror] = useState(false);
  const [errorslash, seterrorslash] = useState(false);
  const [errorOthersCase, setErrorOthersCase] = useState(false);
  const [errorLongTermStages, setErrorLongTermStages] = useState(false);
  const [dentists, setDentists] = useState<any[]>([]);
  const [formData, setformData] = useState({
    treatment: "",
    stages: [] as string[],
    price: 0,
    treatmentid: "",
    type: 0,
    typeId: "",
    subId: "",
    selectedOption: "option1",
    materialCost: 0,
    doctorCommission: 0,
    doctorCommissionOverrides: [] as { dentistId: string; commission: number }[],
    longTermTreatment: false,
  });

  useEffect(() => {
    dispatch(setloadeActive());
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        dispatch(setloadeDeactive());
        setData(response.data.data);
      })
      .catch((error) => {
        dispatch(setloadeDeactive());
        console.log(error);
      });
  }, [dispatch]);

  const mapOverrides = (overrides: any) =>
    (Array.isArray(overrides) ? overrides : []).map((o: any) => ({
      dentistId: o.dentistId?._id || o.dentistId,
      commission: o.commission ?? 0,
    }));

  const mapStages = (stages: any) =>
    Array.isArray(stages) ? stages.map((s) => String(s || "")) : [];

  const getMain = (treatmentid: string) =>
    (data as any[]).find((x: any) => String(x._id) === String(treatmentid));

  const getType = (treatmentid: string, typeId: string) => {
    const main = getMain(treatmentid);
    return main?.type?.find((t: any) => String(t._id) === String(typeId));
  };

  const isActiveType = (t: any) => t?.status2 !== false;

  const findAllType = (treatmentid: string) => {
    const main = getMain(treatmentid);
    return (main?.type || []).find(
      (t: any) =>
        isActiveType(t) && String(t.treatment || "").trim().toLowerCase() === ALL_TYPE_NAME.toLowerCase()
    );
  };

  const getActiveTypes = (treatmentid: string) => {
    const main = getMain(treatmentid);
    return (main?.type || []).filter(isActiveType);
  };

  const applyDefaultsFrom = (src: any, inheritStages = false) => {
    if (!src) return;
    setformData((prev) => {
      const next = {
        ...prev,
        materialCost: isNaN(src.materialCost) ? prev.materialCost : (src.materialCost ?? 0),
        doctorCommission: isNaN(src.doctorCommission) ? prev.doctorCommission : (src.doctorCommission ?? 0),
        doctorCommissionOverrides: mapOverrides(src.doctorCommissionOverrides),
        longTermTreatment: src.longTermTreatment ?? prev.longTermTreatment,
      };
      if (inheritStages && !prev.stages.some((s) => String(s || "").trim())) {
        next.stages = mapStages(src.stages);
      }
      return next;
    });
  };

  const ensureAllType = async (treatmentid: string) => {
    const existing = findAllType(treatmentid);
    if (existing) return String(existing._id);

    const main = getMain(treatmentid);
    if (!main) throw new Error("Treatment not found");

    const payload = {
      treatment: ALL_TYPE_NAME,
      treatmentid,
      price: main.price ?? 0,
      materialCost: main.materialCost ?? 0,
      doctorCommission: main.doctorCommission ?? 0,
      doctorCommissionOverrides: mapOverrides(main.doctorCommissionOverrides),
      stages: mapStages(main.stages),
    };

    const response = await baseUrl.post("alltreatment/createTreatmentType", payload);
    if (!response.data?.success) throw new Error("Failed to create All type");

    const updated = response.data.data;
    setData((prev) =>
      prev.map((item: any) =>
        String(item._id) === String(treatmentid) ? updated : item
      )
    );

    const created =
      (updated?.type || []).find(
        (t: any) => String(t.treatment || "").trim().toLowerCase() === ALL_TYPE_NAME.toLowerCase()
      ) || updated?.type?.[updated.type.length - 1];

    return String(created?._id || "");
  };

  const resolveStagesFromTreatment = (treatmentid: string, stages: string[]) => {
    const trimmed = stages.map((s) => s.trim()).filter(Boolean);
    if (trimmed.length) return trimmed;
    return mapStages(getMain(treatmentid)?.stages).filter((s) => s.trim());
  };

  const applyStageDefaultsFromTreatment = (treatmentid: string) => {
    const resolved = resolveStagesFromTreatment(treatmentid, []);
    if (!resolved.length) return;

    setformData((prev) => {
      if (prev.stages.some((s) => String(s || "").trim())) return prev;
      return { ...prev, stages: resolved };
    });
  };

  const applySubtypeDefaults = (treatmentid: string, typeId?: string) => {
    const src = (typeId ? getType(treatmentid, typeId) : null) || getMain(treatmentid);
    applyDefaultsFrom(src, false);
    applyStageDefaultsFromTreatment(treatmentid);
  };

  const ensureAllTypeAndApplySubtypeDefaults = async (treatmentid: string, typeId?: string) => {
    if (!treatmentid) return;
    try {
      dispatch(setloadeActive());
      if (!findAllType(treatmentid)) {
        await ensureAllType(treatmentid);
      }
      applySubtypeDefaults(treatmentid, typeId);
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setloadeDeactive());
    }
  };

  useEffect(() => {
    baseUrl
      .get("appointment/findAllAppointmentDentist")
      .then((response) => setDentists(response.data.data || []))
      .catch(() => setDentists([]));
  }, []);

  useEffect(() => {
    setedit(
      typeof type !== "object" ||
        (typeof type === "object" && Object.keys(type).length !== 0)
    );
    if (
      typeof type !== "object" ||
      (typeof type === "object" && Object.keys(type).length !== 0)
    ) {
      const overrides = Array.isArray(type?.doctorCommissionOverrides) ? type.doctorCommissionOverrides : [];
      if (type.type === "main") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: (type?.treatment === "Others" ? "others" : type?.treatment) ?? "",
          stages: mapStages(type?.stages),
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          doctorCommissionOverrides: overrides.map((o: any) => ({ dentistId: o.dentistId?._id || o.dentistId, commission: o.commission ?? 0 })),
          longTermTreatment: !!type?.longTermTreatment,
          selectedOption: "option1",
        });
      } else if (type.type === "sub") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: (type?.treatment === "Others" ? "others" : type?.treatment) ?? "",
          stages: mapStages(type?.stages),
          typeId: type?.subId,
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          doctorCommissionOverrides: overrides.map((o: any) => ({ dentistId: o.dentistId?._id || o.dentistId, commission: o.commission ?? 0 })),
          longTermTreatment: !!type?.longTermTreatment,
          selectedOption: "option2",
        });
      } else if (type.type === "subsub") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: (type?.treatment === "Others" ? "others" : type?.treatment) ?? "",
          stages: mapStages(type?.stages),
          typeId: type?.subId,
          subId: type?.subsubId,
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          doctorCommissionOverrides: overrides.map((o: any) => ({ dentistId: o.dentistId?._id || o.dentistId, commission: o.commission ?? 0 })),
          longTermTreatment: !!type?.longTermTreatment,
          selectedOption: "option3",
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync modal `type` prop into form state; including formData would loop
  }, [type]);

  useEffect(() => {
    if (
      (formData.selectedOption !== "option2" && formData.selectedOption !== "option3") ||
      !formData.treatmentid
    ) {
      return;
    }
    if (formData.stages.some((s) => String(s || "").trim())) return;

    const resolved = resolveStagesFromTreatment(formData.treatmentid, formData.stages);
    if (!resolved.length) return;

    setformData((prev) => ({ ...prev, stages: resolved }));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- backfill empty type/subtype stages from parent treatment
  }, [data, formData.treatmentid, formData.selectedOption]);

  const handleChange = (e: any) => {
    if (e.target.type === "checkbox") {
      const checked = e.target.checked;
      setformData({ ...formData, [e.target.name]: checked });
      if (e.target.name === "longTermTreatment" && !checked) {
        setErrorLongTermStages(false);
      }
      return;
    }
    if (e.target.name === "price" && formData.treatment === "others") {
      return;
    }
    // When adding Type/Subtype, prefill commission/cost from parent selection to make it easy to set different values per level
    if (!edit && (e.target.name === "treatmentid" || e.target.name === "typeId")) {
      const { name, value } = e.target;
      const nextTreatmentId = name === "treatmentid" ? value : formData.treatmentid;
      const nextTypeId = name === "typeId" ? value : formData.typeId;

      if (formData.selectedOption === "option3" && name === "treatmentid") {
        const allType = findAllType(value);
        const activeTypes = getActiveTypes(value);
        const autoTypeId =
          allType?._id != null
            ? String(allType._id)
            : activeTypes.length === 1
              ? String(activeTypes[0]._id)
              : "";

        setformData((prev) => ({
          ...prev,
          treatmentid: value,
          typeId: autoTypeId,
        }));

        void ensureAllTypeAndApplySubtypeDefaults(value, autoTypeId);
        return;
      }

      setformData((prev) => ({ ...prev, [name]: value }));

      // Use a microtask so state updates apply before reading dependent values
      queueMicrotask(() => {
        if (formData.selectedOption === "option2") {
          const main = getMain(nextTreatmentId);
          applyDefaultsFrom(main, true);
        } else if (formData.selectedOption === "option3") {
          if (name === "typeId") {
            applySubtypeDefaults(nextTreatmentId, nextTypeId);
          } else {
            void ensureAllTypeAndApplySubtypeDefaults(nextTreatmentId, nextTypeId);
          }
        }
      });
      return;
    }
    if (e.target.name === "doctorCommission") {
      const numericValue = e.target.value.replace(/e/g, 0);
      if (/^\d{0,2}$/.test(numericValue)) {
        setformData({ ...formData, [e.target.name]: numericValue });
      }
    } else if (e.target.name.startsWith("dentistCommission_")) {
      const dentistId = e.target.name.replace("dentistCommission_", "");
      const numericValue = e.target.value === "" ? "" : e.target.value.replace(/e/g, 0);
      if (numericValue === "" || /^\d{0,3}(\.\d*)?$/.test(String(numericValue))) {
        const newOverrides = formData.doctorCommissionOverrides.filter((o) => o.dentistId !== dentistId);
        if (numericValue !== "") {
          newOverrides.push({ dentistId, commission: parseFloat(String(numericValue)) || 0 });
        }
        setformData({ ...formData, doctorCommissionOverrides: newOverrides });
      }
    } else if (
      !edit &&
      e.target.name === "selectedOption" &&
      e.target.value === "option2" &&
      formData.treatmentid
    ) {
      setformData((prev) => ({
        ...prev,
        selectedOption: e.target.value,
      }));

      queueMicrotask(() => {
        const main = getMain(formData.treatmentid);
        applyDefaultsFrom(main, true);
      });
    } else if (!edit && e.target.name === "selectedOption" && e.target.value === "option3" && formData.treatmentid) {
      const allType = findAllType(formData.treatmentid);
      const activeTypes = getActiveTypes(formData.treatmentid);
      const autoTypeId =
        allType?._id != null
          ? String(allType._id)
          : activeTypes.length === 1
            ? String(activeTypes[0]._id)
            : "";

      setformData((prev) => ({
        ...prev,
        selectedOption: e.target.value,
        typeId: autoTypeId,
      }));

      void ensureAllTypeAndApplySubtypeDefaults(formData.treatmentid, autoTypeId);
    } else {
      if (e.target.name === "treatment" && (e.target.value === "Others" || e.target.value === "others")) {
        const normalized = "others";
        setformData({ ...formData, [e.target.name]: normalized, price: 0 });
        setErrorOthersCase(false);
      } else if (e.target.name === "treatment" && /Others/i.test(e.target.value) && e.target.value !== "others") {
        setErrorOthersCase(true);
        setformData({ ...formData, [e.target.name]: e.target.value });
      } else {
        if (e.target.name === "treatment") setErrorOthersCase(false);
        setformData({ ...formData, [e.target.name]: e.target.value });
      }
    }
  };

  const handleStageChange = (index: number, value: string) => {
    setErrorLongTermStages(false);
    setformData((prev) => {
      const stages = [...prev.stages];
      stages[index] = value;
      return { ...prev, stages };
    });
  };

  const addStage = () => {
    setErrorLongTermStages(false);
    setformData((prev) => ({ ...prev, stages: [...prev.stages, ""] }));
  };

  const removeStage = (index: number) => {
    setformData((prev) => ({
      ...prev,
      stages: prev.stages.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (formData.treatment === "") {
      seterror(true);
      return;
    }

    if (formData.treatment.includes("/")) {
      seterrorslash(true);
      return;
    }

    if (/Others/i.test(formData.treatment) && formData.treatment !== "others") {
      setErrorOthersCase(true);
      return;
    }

    let stages = formData.stages.map((s) => s.trim()).filter(Boolean);
    let typeId = formData.typeId;

    if (!edit && (formData?.selectedOption === "option2" || formData?.selectedOption === "option3")) {
      stages = resolveStagesFromTreatment(formData.treatmentid, stages);
    }

    if (formData.longTermTreatment && stages.length === 0) {
      setErrorLongTermStages(true);
      return;
    }

    setErrorLongTermStages(false);

    if (!edit && formData?.selectedOption === "option3") {
      try {
        dispatch(setloadeActive());
        if (!findAllType(formData.treatmentid)) {
          await ensureAllType(formData.treatmentid);
        }
        typeId = typeId || String(findAllType(formData.treatmentid)?._id || "");
        dispatch(setloadeDeactive());
      } catch (error) {
        dispatch(setloadeDeactive());
        console.log(error);
        return;
      }
    }

    const submitData =
      formData.treatment === "others"
        ? { ...formData, typeId, stages, price: 0 }
        : { ...formData, typeId, stages };

    if (!edit) {
      if (formData?.selectedOption === "option2") {
        baseUrl
          .post("alltreatment/createTreatmentType", submitData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Added type:", { treatment: formData.treatment, treatmentid: formData.treatmentid, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      } else if (formData?.selectedOption === "option3") {
        baseUrl
          .post("alltreatment/createTreatmentSubType", submitData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Added subtype:", { treatment: formData.treatment, typeId: submitData.typeId, subId: formData.subId, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      } else {
        baseUrl
          .post("alltreatment/createAllTreatment", submitData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Added treatment:", { treatment: formData.treatment, price: formData.price, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      }
    } else {
      if (formData?.selectedOption === "option2") {
        baseUrl
          .patch("alltreatment/updateTreatmentType", submitData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Updated type:", { treatment: formData.treatment, typeId: formData.typeId, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error.response.data));
      } else if (formData?.selectedOption === "option3") {
        baseUrl
          .patch("alltreatment/updateTreatmentSubType", submitData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Updated subtype:", { treatment: formData.treatment, typeId: formData.typeId, subId: formData.subId, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      } else {
        baseUrl
          .patch("alltreatment/updateAllTreatment", submitData)
          .then((response) => {
            if (response.data.success) {
              console.log("[Treatment] Updated treatment:", { treatment: formData.treatment, treatmentid: formData.treatmentid, price: formData.price, response: response.data });
              close(false);
            }
          })
          .catch((error) => console.log(error));
      }
    }
  };

  const radioOptions = [
    { value: "option1", label: "Treatment", id: "treatment" },
    { value: "option2", label: "Type", id: "Types" },
    { value: "option3", label: "Subtype", id: "SubTypes" },
  ];

  const commissionAmount =
    ((formData.treatment === "others" ? 0 : formData.price) - formData.materialCost) * (formData.doctorCommission / 100);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden max-h-[90vh] overflow-y-auto border border-slate-200 dark:border-slate-700">
        {/* Header */}
        <div className="px-6 py-4 bg-gradient-to-r from-primary to-primaryLight flex items-center justify-between sticky top-0">
          <div className="flex items-center gap-3">
            <MedicalServicesIcon className="text-white" sx={{ fontSize: 24 }} />
            <h2 className="text-lg font-bold text-white">
              {edit ? "Edit Treatment" : "Add Treatment"}
            </h2>
          </div>
          <button
            onClick={() => close(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="p-6 space-y-4">
            {/* Radio Options */}
            <div className="flex gap-2 p-1 bg-slate-100 dark:bg-slate-700 rounded-xl">
              {radioOptions.map((option) => (
                <label
                  key={option.value}
                  className={`flex-1 text-center py-2 rounded-lg cursor-pointer transition-all text-sm font-medium ${
                    formData.selectedOption === option.value
                      ? "bg-white dark:bg-slate-600 text-indigo-600 dark:text-indigo-300 shadow-sm"
                      : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
                  } ${edit ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  <input
                    type="radio"
                    value={option.value}
                    checked={formData.selectedOption === option.value}
                    onChange={handleChange}
                    name="selectedOption"
                    disabled={edit}
                    className="hidden"
                  />
                  {option.label}
                </label>
              ))}
            </div>

            {/* Treatment Select */}
            {formData.selectedOption !== "option1" && (
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                  Select Treatment
                </label>
                <select
                  onChange={handleChange}
                  value={formData.treatmentid}
                  name="treatmentid"
                  disabled={edit}
                  className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50 text-slate-800 dark:text-slate-200"
                >
                  <option value="">Select</option>
                  {(() => {
                    const list = data?.filter((item: any) => item.status1 === true) || [];
                    const others = list.filter((item: any) => (item.treatment === "Others" || item.treatment === "others"));
                    const rest = list.filter((item: any) => item.treatment !== "Others" && item.treatment !== "others");
                    rest.sort((a: any, b: any) => (a.treatment || "").localeCompare(b.treatment || ""));
                    const sorted = [...rest, ...others];
                    return sorted.map((item: any, i: number) => (
                      <option key={i} value={item._id}>{item.treatment}</option>
                    ));
                  })()}
                </select>
              </div>
            )}

            {/* Type Select */}
            {formData.selectedOption === "option3" && (
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                  Select Type
                </label>
                <select
                  onChange={handleChange}
                  value={formData.typeId}
                  name="typeId"
                  disabled={edit}
                  className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50 text-slate-800 dark:text-slate-200"
                >
                  <option value="">Select</option>
                  {data
                    ?.filter(
                      (item: any) =>
                        item._id === formData.treatmentid && item.status1 === true
                    )
                    .map((filteredItem: any) => filteredItem.type)
                    ?.flat()
                    ?.filter((items: any) => items.status2 !== false)
                    .map((item: any, i: number) => (
                      <option key={i} value={item._id}>
                        {item.treatment}
                      </option>
                    ))}
                </select>
              </div>
            )}

            {/* Treatment Name */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                Treatment Name <span className="text-red-500 dark:text-red-400">*</span>
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.treatment}
                name="treatment"
                disabled={edit}
                placeholder="Enter treatment name"
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
              />
              {formData.treatment === "" && error && (
                <p className="mt-1 text-sm text-red-500 dark:text-red-400">Treatment name is mandatory</p>
              )}
              {formData.treatment.includes("/") && errorslash && (
                <p className="mt-1 text-sm text-red-500 dark:text-red-400">Do not include "/"</p>
              )}
              {errorOthersCase && (
                <p className="mt-1 text-sm text-red-500 dark:text-red-400">Use camelCase: &quot;others&quot;</p>
              )}
            </div>

            {/* Long Term Treatment */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                onChange={handleChange}
                checked={formData.longTermTreatment}
                name="longTermTreatment"
                className="hidden"
              />
              <div
                className={`w-5 h-5 rounded flex items-center justify-center transition-colors ${
                  formData.longTermTreatment
                    ? "bg-indigo-500 text-white"
                    : "bg-slate-200 dark:bg-slate-600 text-slate-400 dark:text-slate-500"
                }`}
              >
                {formData.longTermTreatment ? (
                  <CheckBoxIcon sx={{ fontSize: 20 }} />
                ) : (
                  <CheckBoxOutlineBlankIcon sx={{ fontSize: 20 }} />
                )}
              </div>
              <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Long Term Treatment</span>
            </label>

            {/* Stages */}
            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300">
                  Stages
                  {formData.longTermTreatment && (
                    <span className="text-red-500 dark:text-red-400"> *</span>
                  )}
                </label>
                <button
                  type="button"
                  onClick={addStage}
                  className="inline-flex items-center gap-1 text-xs font-medium text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300"
                >
                  <AddIcon sx={{ fontSize: 16 }} />
                  Add stage
                </button>
              </div>
              {formData.stages.length === 0 ? (
                <p className="text-sm text-slate-500 dark:text-slate-400 px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-dashed border-slate-200 dark:border-slate-600 rounded-xl">
                  No stages added yet.
                </p>
              ) : (
                <div className="space-y-2">
                  {formData.stages.map((stage, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <input
                        type="text"
                        value={stage}
                        onChange={(e) => handleStageChange(index, e.target.value)}
                        placeholder={`Stage ${index + 1}`}
                        className="flex-1 px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
                      />
                      <button
                        type="button"
                        onClick={() => removeStage(index)}
                        className="w-10 h-10 flex items-center justify-center rounded-xl border border-slate-200 dark:border-slate-600 text-slate-500 dark:text-slate-400 hover:text-red-500 hover:border-red-200 dark:hover:border-red-800 transition-colors"
                        aria-label={`Remove stage ${index + 1}`}
                      >
                        <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
              {errorLongTermStages && (
                <p className="mt-1 text-sm text-red-500 dark:text-red-400">
                  At least one stage is required for long term treatment
                </p>
              )}
            </div>

            {/* Price */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <div className="flex items-center gap-1">
                  <AttachMoneyIcon sx={{ fontSize: 16 }} />
                  Price
                  {formData.treatment === "others" && (
                    <span className="text-xs font-normal text-slate-500 dark:text-slate-400 ml-1">(set at appointment)</span>
                  )}
                </div>
              </label>
              <input
                type="number"
                onChange={handleChange}
                value={formData.treatment === "others" ? 0 : formData.price}
                name="price"
                disabled={formData.treatment === "others"}
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-60 disabled:cursor-not-allowed text-slate-800 dark:text-slate-200"
              />
            </div>

            {/* Material Cost */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                Material Cost
              </label>
              <input
                type="number"
                onChange={handleChange}
                value={formData.materialCost}
                name="materialCost"
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200"
              />
            </div>

            {/* Doctor Commission (Default) */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                <div className="flex items-center gap-1">
                  <PercentIcon sx={{ fontSize: 14 }} />
                  Doctor Commission (Default)
                </div>
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="number"
                  onChange={handleChange}
                  value={formData.doctorCommission}
                  name="doctorCommission"
                  className="flex-1 px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200"
                />
                <div className="px-4 py-2.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 rounded-xl font-semibold min-w-[100px] text-center">
                  = {commissionAmount.toFixed(2)}
                </div>
              </div>
            </div>

            {/* Commission by Dentist */}
            {dentists.length > 0 && (
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                  Commission by Dentist
                </label>
                <div className="space-y-2 max-h-40 overflow-y-auto rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700/50 p-2">
                  {dentists.map((dentist: any) => {
                    const override = formData.doctorCommissionOverrides.find((o) => o.dentistId === dentist._id);
                    const value = override !== undefined ? override.commission : "";
                    const effectivePrice = formData.treatment === "others" ? 0 : formData.price;
                    const dentCommissionAmount =
                      typeof value === "number"
                        ? (effectivePrice - formData.materialCost) * (value / 100)
                        : commissionAmount;
                    return (
                      <div key={dentist._id} className="flex items-center gap-2">
                        <span className="text-sm text-slate-600 dark:text-slate-400 min-w-[120px] truncate">
                          {dentist.title || dentist.firstName} {dentist.lastName || ""}
                        </span>
                        <input
                          type="number"
                          name={`dentistCommission_${dentist._id}`}
                          value={value}
                          onChange={handleChange}
                          placeholder={`${formData.doctorCommission}% default`}
                          className="flex-1 px-3 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
                        />
                        <span className="text-xs text-emerald-600 dark:text-emerald-400 font-medium w-16 text-right">
                          = {typeof value === "number" ? dentCommissionAmount.toFixed(2) : "-"}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-slate-50 dark:bg-slate-700/50 border-t border-slate-100 dark:border-slate-600 flex justify-end gap-3 sticky bottom-0">
            <button
              type="button"
              onClick={() => close(false)}
              className="px-5 py-2.5 text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-600 border border-slate-200 dark:border-slate-500 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-500 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-xl hover:shadow-lg hover:shadow-primary/20 transition-all font-medium"
            >
              {edit ? "Update" : "Add Treatment"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddTreatmentOne;
